import { useCaseSession } from "../../state/CaseSessionContext";

export function BottomBar() {
  const { currentCase, activeJaw, viewMode, isDirty } = useCaseSession();

  return (
    <footer className="bottom-bar">
      <div>
        {currentCase
          ? `Case: ${currentCase.summary.caseName}`
          : "Case: none selected"}
      </div>

      <div>Active Jaw: {activeJaw}</div>
      <div>View Mode: {viewMode}</div>
      <div className={isDirty ? "bottom-bar__warning" : ""}>
        {isDirty ? "Unsaved changes" : "No unsaved changes"}
      </div>
    </footer>
  );
}